// The finder's matcher, ONE copy (moved here from apps/landing/pages-src/howlong/match.js so core's "left out" engine,
// the web and phone apps, the AI search and the browser finder all use the same one). finder.js gets this text pasted in at
// build time (finderScript() in apps/landing/pages-src/howlong/render.ts, which drops the word "export").
export function norm(s) {
  return String(s).toLowerCase().normalize("NFD").replace(/[̀-ͯ]/g, "").replace(/&/g, " and ").replace(/[^a-z0-9]+/g, " ").trim()
    .split(" ").map(function (w) { return w.length > 4 && /ies$/.test(w) ? w.slice(0, -3) + "y" : w.length > 3 && /[^s]s$/.test(w) ? w.slice(0, -1) : w; }).join(" ");
}
export function dist(a, b, max) { // Levenshtein with transpositions, stops early past max
  if (Math.abs(a.length - b.length) > max) return max + 1;
  var p = [], c, pp = null, i, j;
  for (j = 0; j <= b.length; j++) p[j] = j;
  for (i = 1; i <= a.length; i++) {
    c = [i]; var lo = i;
    for (j = 1; j <= b.length; j++) {
      var v = Math.min(p[j] + 1, c[j - 1] + 1, p[j - 1] + (a[i - 1] === b[j - 1] ? 0 : 1));
      if (pp && i > 1 && j > 1 && a[i - 1] === b[j - 2] && a[i - 2] === b[j - 1]) v = Math.min(v, pp[j - 2] + 1);
      c[j] = v; if (v < lo) lo = v;
    }
    if (lo > max) return max + 1;
    pp = p; p = c;
  }
  return p[b.length];
}
export function wordScore(q, w) {
  if (q === w) return 1;
  if (q.length >= 3 && w.indexOf(q) === 0) return 0.9;
  var max = q.length >= 7 ? 2 : q.length >= 4 ? 1 : 0;
  return max && dist(q, w, max) <= max ? 0.75 : 0;
}
export function score(q, e) {
  var best = 0, qw = q.split(" ");
  e.t.forEach(function (t) {
    if (t === q) best = Math.max(best, 100);
    else if (q.length >= 3 && t.indexOf(q) >= 0) best = Math.max(best, 80);
    var tw = t.split(" "), sum = 0;
    qw.forEach(function (x) { var m = 0; tw.forEach(function (w) { m = Math.max(m, wordScore(x, w)); }); sum += m; });
    var avg = sum / qw.length; if (avg >= 0.75) best = Math.max(best, 60 * avg);
  });
  return best;
}
